// src/layouts/MainLayout.jsx

import React from "react";
import { Outlet } from "react-router-dom";
import UserMenu from "../components/UserMenu";
import { ActiveModuleProvider } from "../components/ActiveModuleContext";

export default function MainLayout() {
  return (
    // 🔹 Envolvemos todo el layout con el provider del módulo activo
    <ActiveModuleProvider>
      <div className="flex flex-col min-h-screen">
        {/* 🔹 Header */}
        <header className="bg-primary text-white flex justify-between items-center px-6 py-3 shadow-md z-30">
          <div className="flex items-center gap-3">
            <img
              src="/assets/iconos/logo_libelula.png"
              alt="Logo"
              className="h-8 w-auto"
            />
            <h1 className="font-semibold">
              Portal Colaboradores Piedecuestana E.S.P.
            </h1>
          </div>

          {/* 🔹 Menú del usuario */}
          <UserMenu />
        </header>

        {/* 🔹 Contenido principal */}
        <main className="flex-1 bg-gray-50 p-6">
          <Outlet /> {/* 🔹 Renderiza las rutas hijas */}
        </main>

        {/* 🔹 Footer */}
        <footer className="bg-gray-200 py-4 text-sm text-gray-700">
          <div className="container mx-auto flex flex-col sm:flex-row justify-between items-center px-4">
            <span>
              © {new Date().getFullYear()} Piedecuestana de Servicios Públicos E.S.P.
            </span>
            <span className="mt-2 sm:mt-0 text-primary font-medium">
              By Duver Jaimes
            </span>
          </div>
        </footer>
      </div>
    </ActiveModuleProvider>
  );
}
